import { API_PATHS } from "../constants/api-paths";
import { logErrorToNewRelic } from "../utils/logging";
import { IResponse, request } from "../core/api.client";

export interface IBusinessDetailResponse {
  id: string;
  tags: string | null;
  brand_name: string | null;
  brand_store_locator_name: string | null;
  company_tagline: string | null;
  brand_website: string | null;
  short_description: string;
  description: string;
  twitter_handle: string | null;
  instagram: string | null;
  pinterest: string | null;
  youtube_channel_url: string | null;
  facebook_page_national_url: string | null;
  google_plus_page_national_url: string | null;
  logo: string | null;
  facebook_profile_photo: string | null;
  facebook_cover_photo: string | null;
  buy_online_url: string | null;
  meta_additional_keywords: string | null;
  latitude: string;
  longitude: string;
  geo_coded_latitude: string | null;
  geo_coded_longitude: string | null;
  url_alias: string;
  business_name: string;
  location: string;
  city: string;
  zip: string;
  address: string;
  address_2: string;
  phone: string;
  business_hours: string;
  weekly_off: string;
  alternative_name: string;
  landmark: string;
  state: string;
  circle: string;
  alternative_phone: string;
  fax_no: string;
  contact_person_name: string;
  contact_person_email: string;
  contact_person_number: string;
  mobile_number: string;
  external_links: string;
  googleplus_url: string;
  country: string;
  website: string;
  client_website: string | null;
  enterprise_client_store_id: string;
  enterprise_actual_client_store_id: string;
  ifsc_code: string;
  iso_alpha_2: string;
  outlet_fav_icon_url: string;
  business_email: string;
  circle_alias: string;
  state_alias: string;
  city_alias: string;
  location_alias: string;
  custom_state: string;
  custom_city: string;
  custom_state_alias: string;
  custom_city_alias: string;
  outlet_logo_url: string;
  distance: string;
  gmcProductPageLink: string | null;
  directionButtonUrl: string;
  arrOutletSpecificGoogleRating: number;
}

export interface IBranchDetailsReqData {
  limit?: number;
  lat?: string;
  long?: string;
  pincode?: string;
  business?: string;
}

const getBranchDetailsByBusiness = async (
  reqData: IBranchDetailsReqData
): Promise<IResponse<IBusinessDetailResponse[]> | undefined> => {
  try {
    const response = await request<IBusinessDetailResponse[], IBranchDetailsReqData>({
      method: "POST",
      url: API_PATHS.branchDetails,
      data: reqData,
    });
    if (response.statusCode !== 90) {
      throw new Error(response.message);
    }
    return response;
  } catch (err) {
    logErrorToNewRelic(err as Error);
  }
};

export default getBranchDetailsByBusiness;
